<app-grid
    [columns]="columns"
    [rows]="data.tableRows"
    [tableParams]="data.tableParams"
    [gridName]="gridName"
    [multiSelect]="false"
    #origin
    [allowCopy]="true"
    (copyClicked)="copyScheduleClicked($event)"
    (addClicked)="addScheduleClicked(origin)"
    (editClicked)="veiwDetialsClicekd('edit')"
    (deleteClicked)="deleteScheduleClicked()"
    (refreshDataFromServer)="refreshData($event)"
    (rowSelected)="onRowClick($event)"
    (viewAllClicked)="veiwDetialsClicekd('view-all')"
    (exportClicked)="exportScheduleClicked()"
    (selectAllClicked)="selectAllSchClicked()"

></app-grid>
